import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// On sitting: the cue, then a soft 3 · 2 · 1 before the memories begin.
export function SitCountdown() {
  const [n, setN] = useState(4);
  useEffect(() => {
    if (n <= 0) return;
    const id = setTimeout(() => setN(n - 1), n === 4 ? 1600 : 900);
    return () => clearTimeout(id);
  }, [n]);
  return (
    <AnimatePresence>
      {n > 0 && (
        <motion.div data-testid="sit-countdown" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0, transition: { duration: 1 } }} transition={{ duration: 0.8 }} className="pointer-events-none absolute inset-0 z-20 flex flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="font-display text-xl italic text-[#F3E8FF]/90 sm:text-2xl">The memories begin in a moment.</p>
          <AnimatePresence mode="wait">
            {n <= 3 && (
              <motion.span key={n} data-testid="sit-countdown-number" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 0.7, scale: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.45 }} className="font-display text-4xl font-light text-[#F3E8FF]">
                {n}
              </motion.span>
            )}
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
